import type { JSX, ButtonHTMLAttributes } from 'react';
import { useNavigateQuery } from '@CS/hooks';
import ButtonStyle from './Button.styles';
import type { MouseEvent } from 'react';
import { pushEvent } from '@CS/hooks';

type Child = JSX.Element | string;
type Children<Child> = Child | Child[];
type ClickEvent = MouseEvent<HTMLButtonElement>;

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  onClick?: (event: ClickEvent) => unknown;
  type?: 'button' | 'submit' | 'reset';
  children?: Children<Child>;

  gtmConfig?: object;
  disabled?: boolean;
  blank?: boolean;

  width?: string;
  link?: string;
  text?: string;
  id?: string;
};

export const Button = ({
  text = '',
  gtmConfig,
  disabled,
  children,
  onClick,
  width,
  blank,
  link,
  id,
  ...props
}: ButtonProps) => {
  const navigate = useNavigateQuery();

  const onButtonClick = (event: ClickEvent) => {
    gtmConfig && pushEvent(gtmConfig);

    if (!link) onClick?.(event);
    else if (blank) open(link, '_blank');
    else navigate(link);
  };

  return (
    <ButtonStyle
      onClick={onButtonClick}
      disabled={disabled}
      width={width}
      {...props}
      id={id}
    >
      {text || children}
    </ButtonStyle>
  );
};
